module.exports = __webpack_public_path__ + "img/part2-watermark.09f49529.png";